module.exports = __webpack_public_path__ + "static/img/Anthony-Minichiello.800f429.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Anthony-Minichiello.jpg
// module id = T1h8
// module chunks = 0